import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  useSummarySidebarContentContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Context';
import PrimaryCard from 'Components/ComponentLibrary/Molecules/PrimaryCard';
import List1 from 'Components/ComponentLibrary/Components/Lists/List1';
import ListItem2 from 'Components/ComponentLibrary/Components/ListItems/ListItem2';
import ListItemText1 from 'Components/ComponentLibrary/Components/Uncategorized/ListItemText/ListItemText1';
import ListItemSecondaryAction
  from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemSecondaryAction';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {
  FACET_PLAN_SIDEBAR_QUERY_PARAM,
  FACET_PLAN_VIEW_SIDEBAR_EXPENSES,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Components/Sidebar/consts';
import useQueryParams from 'Hooks/useQueryParams';
import { currency } from 'Helpers/Formats';

const styles = () => ({
  root: {},
});

const ExpenseSectionSummary = ({
  className,
  classes,
}) => {
  const { facetPlanInputCollection: facetPlanInputResource } = useSummarySidebarContentContext();
  const [params, setParams] = useQueryParams();

  const expenseResource = useMemo(() => {
    return facetPlanInputResource?.attr('expenseSections').resources()
      .head();
  }, [facetPlanInputResource]);

  const expenseSummaryItems = expenseResource
    .meta()
    .template()
    .list()
    .filter(field => field.attr('name') !== 'expenses')
    .map(expenseSummaryItem => {
      return {
        key: expenseSummaryItem.attr('name'),
        test: `${expenseSummaryItem.attr('name')}-summary-item`,
        title: expenseSummaryItem.attr('prompt'),
        value: expenseResource.attr(expenseSummaryItem.attr('name')),
      };
    });

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <PrimaryCard
        title={'Expenses'}
      >
        {expenseSummaryItems.map(expenseSummaryItem => {
          return (
            <List1
              key={expenseSummaryItem.key}
            >
              <ListItem2
                className={classes.listItem}
                color={'accentBlue20'}
                button
                onClick={() => {
                  params.set(FACET_PLAN_SIDEBAR_QUERY_PARAM, FACET_PLAN_VIEW_SIDEBAR_EXPENSES);
                  setParams(params);
                }}
                test={expenseSummaryItem.test}
              >
                <ListItemText1
                  primary={currency(expenseSummaryItem.value, true)}
                  secondary={expenseSummaryItem.title}
                />

                <ListItemSecondaryAction
                  className={classes.secondaryAction}
                >
                  <IconButton
                    icon={ChevronRightIcon}
                  />
                </ListItemSecondaryAction>
              </ListItem2>
            </List1>
          );
        })}
      </PrimaryCard>
    </Box>
  );
};

ExpenseSectionSummary.defaultProps = {
  className: '',
};

ExpenseSectionSummary.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ExpenseSectionSummary);
